import axios, { AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus'
import { getCookie, clearAllCookie } from './cookei'
const service = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    // withCredentials: false,
})

// 请求拦截器
service.interceptors.request.use(
    (config: any) => {
        // 从r路由中获取token
        const token = getCookie('Token')
        config.headers = {token: token}
        const netInfo:any = navigator
        const track = {
            network: netInfo.connection ? netInfo.connection.effectiveType : 'unknown',
            source: "web"
        }
        // 将track转为base64
        const trackBase64 = btoa(JSON.stringify(track))
        if (config.url.includes('aippt/get_authcode') || config.url.includes('/aippt/track')) {
            config.headers = {
                token: token, 
                track: trackBase64,
            }
        }
        return config
    },
    (error: any) => {
        // do something with request error
        return Promise.reject(error)
    }
)
// 相应拦截器
service.interceptors.response.use(
    (response: AxiosResponse) => {
        const res = response.data
        if (res.code == 400) {
            if (res.msg == 'Token 为空') {
                ElMessage.error('登录失效，请重新登录')
            }else{
                ElMessage.error(res.msg)
            }
            setTimeout(() => {
                clearAllCookie();
                window.location.reload();
            }, 2000);
        }
        return res
    },
    (error: any) => {
        console.log('err' + error) // for debug
      
        return Promise.reject(error)
    }
)
export default service
